import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { router } from './router';
import { AuthProvider } from './lib/auth';
import { ToastProvider } from './components/Toast/ToastProvider';
import { readStoredTheme } from './hooks/useTheme';
import './lib/chartSetup';
import './styles/variables.css';
import './styles/reset.css';
import './styles/global.css';

// Apply the persisted theme before first paint to avoid a flash.
document.documentElement.setAttribute('data-theme', readStoredTheme());

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false } },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ToastProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
